export default {
	emits: ['clickBarraChart'],
	props: {
		clientes_sem_reuniao_por_periodo: {
			type: Object,
			required: false,
			default: () => ({
				'1-3 meses': {
					politicas: { 'SAI/Cliente': 0, SAI: 0, 'N/A': 0, 'Consultor/Gestor': 0 },
					total: 0,
					porcentagem: 0,
				},
				'4-6 meses': {
					politicas: { 'SAI/Cliente': 0, SAI: 0, 'N/A': 0, 'Consultor/Gestor': 0 },
					total: 0,
					porcentagem: 0,
				},
				'7-9 meses': {
					politicas: { 'SAI/Cliente': 0, SAI: 0, 'N/A': 0, 'Consultor/Gestor': 0 },
					total: 0,
					porcentagem: 0,
				},
				'10+ meses': {
					politicas: { 'SAI/Cliente': 0, SAI: 0, 'N/A': 0, 'Consultor/Gestor': 0 },
					total: 0,
					porcentagem: 0,
				},
			}),
		},
	},
	data() {
		return {
			chart: null,
		}
	},
	computed: {
		chartData() {
			if (!this.clientes_sem_reuniao_por_periodo) {
				return []
			}
			
			const periodos = ['1-3 meses', '4-6 meses', '7-9 meses', '10+ meses']
			const dadosProcessados = periodos.map((periodo) => {
				const dados = this.clientes_sem_reuniao_por_periodo[periodo] || {
					total: 0,
					porcentagem: 0,
					politicas: {},
				}
				return {
					periodo,
					total: dados.total,
					porcentagem: dados.porcentagem,
					politicas: dados.politicas || {},
				}
			})
			return dadosProcessados
		},
		chartOptions() {
			return {
				series: [
					{
						name: 'Percentual de Fundações',
						data: this.chartData.map((d) => d.porcentagem),
					},
				],
				chart: {
					type: 'bar',
					height: 350,
					toolbar: { show: false },
				},
				colors: ['#18b25d', '#ffc107', '#ec3539', '#ec3539'],
				plotOptions: {
					bar: {
						borderRadius: 6,
						columnWidth: '50%',
						dataLabels: { position: 'top' },
						distributed: true,
					},
				},
				dataLabels: {
					enabled: true,
					formatter: (val) => `${val.toFixed(1)}%`,
					offsetY: -30,
					style: {
						fontSize: '13px',
						colors: ['#304758'],
					},
				},
				xaxis: {
					categories: this.chartData.map((d) => d.periodo),
					position: 'bottom',
					axisBorder: { show: false },
					axisTicks: { show: false },
					labels: {
						style: { fontSize: '13px' },
					},
				},
				yaxis: {
					min: 0,
					max: 100,
					tickAmount: 5,
					labels: {
						formatter: (val) => `${val}%`,
						style: { fontSize: '13px' },
					},
				},
				grid: {
					yaxis: { lines: { show: true } },
					xaxis: { lines: { show: false } },
				},
				title: {
					text: 'Distribuição das Fundações por Tempo sem Atendimento (Políticas)',
					align: 'center',
					style: { fontSize: '16px', color: '#444' },
				},
				tooltip: {
					custom: ({ seriesIndex, dataPointIndex, w }) => {
						const dados = this.chartData[dataPointIndex]
						const politicas = dados.politicas
						const totalPoliticas = Object.values(politicas).reduce(
							(sum, val) => sum + val,
							0
						)

						// Calcular percentuais por política
						const percentuaisPoliticas = {}
						Object.keys(politicas).forEach((key) => {
							percentuaisPoliticas[key] =
								totalPoliticas > 0
									? ((politicas[key] / totalPoliticas) * 100).toFixed(1)
									: 0
						})

						return `
							<div style="padding: 12px; background: white; border: 1px solid #e3e3e3; border-radius: 4px; font-family: Arial, sans-serif;">
								<div style="margin-bottom: 8px;">
									<strong>Faixa:</strong> ${dados.periodo}
								</div>
								<div style="margin-bottom: 8px;">
									<strong>Total de fundações:</strong> ${dados.total}
								</div>
								<div style="margin-bottom: 8px;">
									<strong>Percentual do total:</strong> ${dados.porcentagem.toFixed(1)}%
								</div>
								<div style="margin-top: 12px; padding-top: 8px; border-top: 1px solid #e3e3e3;">
									<div style="font-weight: bold; margin-bottom: 6px;">Distribuição por política:</div>
									${
										politicas['SAI/Cliente'] !== undefined
											? `<div style="margin-bottom: 4px;">SAI/Cliente: ${percentuaisPoliticas['SAI/Cliente']}%</div>`
											: ''
									}
									${
										politicas['SAI'] !== undefined
											? `<div style="margin-bottom: 4px;">SAI: ${percentuaisPoliticas['SAI']}%</div>`
											: ''
									}
									${
										politicas['N/A'] !== undefined
											? `<div style="margin-bottom: 4px;">N/A: ${percentuaisPoliticas['N/A']}%</div>`
											: ''
									}
									${
										politicas['Consultor/Gestor'] !== undefined
											? `<div style="margin-bottom: 4px;">Consultor/Gestor: ${percentuaisPoliticas['Consultor/Gestor']}%</div>`
											: ''
									}
								</div>
							</div>
						`
					},
				},
			}
		},
	},
	methods: {
		renderChart() {
			if (this.chart) {
				this.chart.destroy()
			}
			this.chart = new ApexCharts(
				this.$refs.chartFundacaoPeriodoContainer,
				this.chartOptions
			)
			this.chart.render()

			this.chart.addEventListener(
				'dataPointSelection',
				(event, chartContext, config) => {
					const dados = this.chartData[config.dataPointIndex]
					this.$emit('clickBarraChart', {
						index: config.dataPointIndex,
						categoria: dados.periodo,
						valor: dados.porcentagem,
						total: dados.total,
						politicas: dados.politicas,
					})
				}
			)
		},
	},
	watch: {
		clientes_sem_reuniao_por_periodo: {
			handler() {
				this.renderChart()
			},
			deep: true,
		},
	},
	mounted() {
		this.renderChart()
	},
	beforeUnmount() {
		if (this.chart) this.chart.destroy()
	},
	template: `
        <div ref="chartFundacaoPeriodoContainer"></div>
    `,
}
